// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"PlaceBid_text-gradient__3sCM8","subtitle":"PlaceBid_subtitle__dtXR_","box":"PlaceBid_box__1UJAT","input":"PlaceBid_input__3m-aO","prefix":"PlaceBid_prefix__6NYis"};